import React, { Fragment } from 'react'
import {
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Divider,
  Table
} from '@material-ui/core'

import { BookingsTableHead, BookingsTableBody } from 'components/Bookings/components'

const columnData = [
  { id: 'serial', label: '#' },
  { id: 'from', label: 'Звідки' },
  { id: 'to', label: 'Куди' },
  { id: 'surname', label: 'Прізвище' },
  { id: 'name', label: 'Імя' },
  { id: 'phone', label: 'Телефон' },
  { id: 'price', label: 'Ціна' },
  { id: 'note', label: 'Відмітка' },
]

export const SourceBookingsBase = ({ data: { sourceId, label }, onClose, requestSortHandler, sourcesBookings,
  onSortResetClickHandler, order, orderBy }) => {
  const bookings = sourcesBookings.filter(({ sourceId: id }) => id === sourceId)

  return (
    <Fragment>

      <DialogTitle>
        Бронювання системи {label}
      </DialogTitle>

      <Divider />

      <DialogContent>
        <Table>
          <BookingsTableHead
            order={order}
            orderBy={orderBy}
            padding='none'
            columnData={columnData}
            requestSort={requestSortHandler}
            onSortResetClick={onSortResetClickHandler}
          />
          <BookingsTableBody
            order={order}
            orderBy={orderBy}
            bookings={bookings}
          />
        </Table>
      </DialogContent>

      <DialogActions>
        <Button color='secondary' onClick={onClose}>
          Вийти
        </Button>
      </DialogActions>

    </Fragment>
  )
}



// WEBPACK FOOTER //
// ./src/components/EnhancedModal/components/SourceBookings/SourceBookings.js